import {backend} from '@eitje/api'
import {setArbitrary} from '~/hooks'
import {useAsyncEffect} from '@eitje/hooks'

export const useFetchLeads = () => {
	useAsyncEffect(async () => {
		const {ok, data} = await backend.get('trial_conversion/aggregates')
		if (ok && data?.months) {
			setArbitrary('leads', data.months)
		}
	}, [])
}
